module.exports =  {
  blogPostDir: 'contents',
  siteTitle: 'nc',
  pathPrefix: '/',
  siteDescription: 'nc',
  siteRss: '/rss.xml',
  userTwitter: 'enceanggoro',
  icon: './src/assets/icons/Ironman-Mask-3-Old-icon.png',
  userLinks: [
    {
      label: 'Twitter',
      url: 'https://twitter.com/enceanggoro',
      iconClassName: 'fa fa-twitter'
    },
    {
      label: 'Email',
      url: 'mailto:ncanggoro@tutanota.com',
      iconClassName: 'fa fa-envelope'
    }
  ],
  copyright: 'Copyright © 2016, nc.'
};